import {Box} from '@mui/material';
import React from 'react';

import {MOON_250} from '../../../../common/css/color.styles';

export const NotApplicable = () => {
  return <Box sx={{color: MOON_250}}>N/A</Box>;
};
